import { Transforms } from 'slate';
import { DomEditor } from '@wangeditor/core';
// 自定义扩展wangEditor菜单
export class MyButtonMenu { // JS 语法
  constructor(title) {
    this.title = title || '48%'; // 自定义菜单标题
    // this.iconSvg = '<svg>...</svg>' // 可选
    this.tag = 'button';
  }
  getSelectedNode(editor) {
    return DomEditor.getSelectedNodeByType(editor, 'image');
  }
  // 获取菜单执行时的 value ，用不到则返回空 字符串或 false
  getValue(editor) { // JS 语法
    return false;
  }

  // 菜单是否需要激活（如选中加粗文本，“加粗”菜单会激活），用不到则返回 false
  isActive(editor) { // JS 语法
    return false;
  }

  // 菜单是否需要禁用（如选中 H1 ，“引用”菜单被禁用），用不到则返回 false
  isDisabled(editor) { // JS 语法
    return false;
  }

  // 点击菜单时触发的函数
  exec(editor, value) { // JS 语法
    if (this.isDisabled(editor)) return;

    const imageNode = this.getSelectedNode(editor);
    if (imageNode == null) return;

    // 隐藏 hoverbar
    const hoverbar = DomEditor.getHoverbar(editor);
    if (hoverbar) hoverbar.hideAndClean();
    const { style = {} } = imageNode;
    const props = {
      style: {
        ...style,
        width: this.title, // 修改 width
        height: '', // 清空 height
      },
    };

    Transforms.setNodes(editor, props, {
      match: n => DomEditor.checkNodeType(n, 'image'),
    });
  }
}
// export class MyTest { // JS 语法
//   constructor(option) {
//     this.title = option.title; // 自定义菜单标题
//     // this.iconSvg = '<svg>...</svg>' // 可选
//     this.tag = 'button';
//   }

//   // 获取菜单执行时的 value ，用不到则返回空 字符串或 false
//   getValue(editor) { // JS 语法
//     return `<span class="test data-test='111'>${this.title}</span>`;
//   }

//   // 菜单是否需要激活（如选中加粗文本，“加粗”菜单会激活），用不到则返回 false
//   isActive(editor) { // JS 语法
//     return false;
//   }

//   // 菜单是否需要禁用（如选中 H1 ，“引用”菜单被禁用），用不到则返回 false
//   isDisabled(editor) { // JS 语法
//     return false;
//   }

//   // 点击菜单时触发的函数
//   exec(editor, value) { // JS 语法
//     if (this.isDisabled(editor)) return;
//     editor.dangerouslyInsertHtml(`<h1 data-test='test'>标题</h1><p>文本 <b>加粗</b><p data-name='test1'>2333</p></p>`);
//     // editor.dangerouslyInsertHtml(value); // value 即 this.value(editor) 的返回值
//   }
// }
export class BrMenu {
  constructor() {
    this.title = '换行';
    this.tag = 'button';
  }
  getValue() { return ''; }
  isActive() { return false; }
  isDisabled() { return false; }
  exec(editor) {
    if (this.isDisabled(editor)) return;

    editor.dangerouslyInsertHtml(`<br />`);
  }
}
